import { render, staticRenderFns } from "./RubricsContainer.vue?vue&type=template&id=1284bc64&scoped=true"
import script from "./RubricsContainer.vue?vue&type=script&lang=js"
export * from "./RubricsContainer.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=1284bc64&prod&scoped=true&lang=css&external"
import style1 from "./RubricsContainer.vue?vue&type=style&index=1&id=1284bc64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1284bc64",
  null
  
)

export default component.exports